import { useMemo } from "react";

import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { GeographicInfoState } from "@/Common/Models/Localization/GeographicInfoState";

interface UserLocation {
    geoCountry: GeographicInfoCountry;
    geoState: GeographicInfoState;
    countryLookup: FlatLookupView;
    stateLookup: FlatLookupView;
}

/**
 * Get the country and state of the current user's active site preferred address.
 * @returns The current user's active site preferred address country and state lookups and the GeographicCountry and GeographicState.
 */
const useUserLocation = (): UserLocation => useMemo(
    () => {
        const preferredAddress = sessionStore.getCurrentEmployee()?.getActiveSite()?.getPreferredAddress();
        const countryLookup = cacheStore.GetLookupById(preferredAddress?.CountryLookupId);
        const stateLookup = cacheStore.GetLookupById(preferredAddress?.StateLookupId);
        const geoCountry = cacheStore.LocationMapper.getGeoCountryByLookupId(countryLookup?.LookupID);
        const geoState = cacheStore.LocationMapper.getGeoStateByLookupId(stateLookup?.LookupID);

        return {
            geoCountry,
            geoState,
            countryLookup,
            stateLookup
        };
    },
    []
);

export { UserLocation, useUserLocation };
